import React from 'react';

const Panel = ({children, className}) => {
    return (
        <div className={["w-[320px] max-w-[calc(100vw-24px)] max-h-[calc(100vh-90px)] flex flex-col gap-2.5 overflow-y-auto p-2 pr-1", className].join(" ")}>
            {children}
        </div>
    );
};

export default Panel;
